import React, {forwardRef} from 'react'

import Input from '../Input'
import {IInputProps} from '../Input/Input'

interface IInputExpirationDateProps extends IInputProps {}

const InputExpirationDate = forwardRef<HTMLInputElement, IInputExpirationDateProps>(
	(props, ref) => {
		const {onChange} = props

		const onChangeDate = (e: React.ChangeEvent<HTMLInputElement>) => {
			const value = e.target?.value
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			const [_, day, mounth] = value.replace(/\D/g, '').match(/(\d{0,2})(\d{0,2})/) || []
			const newValue = day.length === 2 && !!mounth ? `${day}/${mounth}` : `${day}`

			e.target.value = newValue
			onChange && onChange(e)
		}

		return <Input {...props} onChange={onChangeDate} ref={ref} />
	},
)

InputExpirationDate.displayName = 'InputExpirationDate'

export default InputExpirationDate
